import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/auth";
import { CountryProvider } from "./context/country";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ProductContextProvider from "./context/ProductContext";
import { CartProvider } from "./context/cart";
import { WishlistProvider } from "./context/WishlistContext";
import TryOn from "./tryon/Tryon";
import { TryonProvider } from "./context/TryOnContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();
root.render(
  <AuthProvider>
    <CartProvider>
      <CountryProvider>
        <BrowserRouter>
          <ProductContextProvider>
            <QueryClientProvider client={queryClient}>
              <WishlistProvider>
                <TryonProvider>
                <App />
                </TryonProvider>
              </WishlistProvider>
            </QueryClientProvider>
          </ProductContextProvider>
        </BrowserRouter>
      </CountryProvider>
    </CartProvider>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
